import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const MetadataField = ({ label, children }) => (
  <Styles.Row>
    <Text tag="span" type="bodyMBold">
      {label}:
    </Text>
    <Text tag="span" type="bodyMRegular">
      {children}
    </Text>
  </Styles.Row>
)

export default MetadataField
